module.exports = __webpack_public_path__ + "img/virtual_electrical_fault.e062327a.svg";